export function mobileNav() {
    const $body = $("body");
    const $mainNavHolder = $(".main-nav-holder");
    const $mobileLanguageSwitcherDrop = $(".mobile-language-switcher-drop");
    const menuDrop = $mainNavHolder.find(".menu-item-has-children");
    const searchPopup = $("#search-popup");
    const searchOpener = $(".main-search-opener");
    const searchClose = searchPopup.find(".search-close");
    const miniCartPopup = $(".main-mini-cart-popup");
    const sizeTablePopup = $(".size-table-popup");
    const miniCartPopupClose = miniCartPopup.find(".close-modal");
    const sizeTablePopupClose = sizeTablePopup.find(".close-modal");
    $(".mobile-menu-opener").on("click", function (e) {
        if (!$body.hasClass("menu-opened")) {
            $body.addClass("menu-opened");
            searchPopup.removeClass("open");
        } else {
            $body.removeClass("menu-opened");
            $(".custom-dropdown, .mobile-language-switcher-drop").removeClass("open");
            $mainNavHolder.removeClass("drop-show");
        }
        e.preventDefault();
    });
    menuDrop.each(function (i, it) {
        $(it).find(">a").after("<button class='menu-drop-opener'><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
            "<path d=\"M7.99904 11.2004C7.53237 11.2004 7.0657 11.0204 6.71237 10.6671L2.3657 6.32042C2.17237 6.12708 2.17237 5.80708 2.3657 5.61375C2.55904 5.42042 2.87904 5.42042 3.07237 5.61375L7.41904 9.96042C7.73904 10.2804 8.25904 10.2804 8.57904 9.96042L12.9257 5.61375C13.119 5.42042 13.439 5.42042 13.6324 5.61375C13.8257 5.80708 13.8257 6.12708 13.6324 6.32042L9.2857 10.6671C8.93237 11.0204 8.4657 11.2004 7.99904 11.2004Z\" fill=\"#292D32\"/>\n" +
            "</svg></button>");
        $(it).find(".custom-dropdown ul li:first-child >a").after("<button class='menu-drop-close'></button>")
    });
    $body.on("click", ".menu-drop-opener", function (e) {
        if (!$(this).siblings(".custom-dropdown").hasClass("open")) {
            $(this).siblings(".custom-dropdown").addClass("open");
            $(this).parents(".menu-item-has-children").addClass("drop-show");
        } else {
            $(this).siblings(".custom-dropdown").removeClass("open");
            $(this).parents(".menu-item-has-children").removeClass("drop-show");
        }
        e.preventDefault();
    });
    $body.on("click", ".menu-drop-close", function (i, it) {
        $(this).parents(".custom-dropdown").removeClass("open");
    });
    $(".mobile-language-switcher-opener").on("click", function (e) {
        $mobileLanguageSwitcherDrop.addClass("open");
        e.preventDefault();
    });
    $(".mobile-language-switcher-close").on("click", function (e) {
        $mobileLanguageSwitcherDrop.removeClass("open");
        e.preventDefault();
    });
    searchOpener.on("click", function (e) {
        searchPopup.addClass("open");
        e.preventDefault();
    });
    searchClose.on("click", function (e) {
        searchPopup.removeClass("open");
        e.preventDefault();
    });
    $(".cart-popup-opener").on("click", function (e) {
        e.preventDefault();
        miniCartPopup.addClass("open");
        $body.addClass("mini-cart-opened");
        searchPopup.removeClass("open");
    });
    $(".size-table-button").on("click", function (e) {
        e.preventDefault();
        sizeTablePopup.addClass("open");
        $body.addClass("mini-cart-opened");
    });
    miniCartPopupClose.on("click", function (e) {
        e.preventDefault();
        miniCartPopup.removeClass("open");
        $body.removeClass("mini-cart-opened");
        searchPopup.removeClass("open");
    });
    sizeTablePopupClose.on("click", function (e) {
        e.preventDefault();
        sizeTablePopup.removeClass("open");
        $body.removeClass("mini-cart-opened");
    });
    miniCartPopup.find(".modal-overlay").on("click", function (e) {
        e.preventDefault();
        miniCartPopup.removeClass("open");
        $body.removeClass("mini-cart-opened");
    });
    sizeTablePopup.find(".modal-overlay").on("click", function (e) {
        e.preventDefault();
        sizeTablePopup.removeClass("open");
        $body.removeClass("mini-cart-opened");
    });

    $body.on("click", ".woocommerce-notices-close", function (e) {
        e.preventDefault();
        $(".woocommerce-notices-close").parents(".woocommerce-message").slideUp(500);
        setTimeout(function () {
            $(".woocommerce-notices-close").parents(".woocommerce-message").remove();
        }, 1000);
    });
    $(".mobile-order-details-opener").on("click", function (e) {
        e.preventDefault();
        $body.addClass("order-summary-wrap-opened");
    });
    $(".order-summary-wrap .close").on("click", function (e) {
        e.preventDefault();
        $body.removeClass("order-summary-wrap-opened");
    });

    $('.order-summary-wrap').on('click', function(e) {
        if (e.target !== this)
            return;

        $body.removeClass("order-summary-wrap-opened");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js